import { Component, ViewChild, OnDestroy } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';
import { ModalBase } from 'src/app/model/modal-base';
import { OrderService } from 'src/app/services';
import { PriceService } from 'src/app/services/price.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-secure-pay-modal',
    templateUrl: 'secure-pay-modal.component.html',
    styleUrls: ['secure-pay-modal.component.scss']
})
export class SecurePayModalComponent extends ModalBase implements OnDestroy
{
    public frameUri: string;

    @ViewChild('modal', { static: true })
    public modal: ModalComponent;

    private readonly orderService: OrderService;
    private readonly priceService: PriceService;
    private priceSubscription: Subscription;

    public constructor(orderService: OrderService, priceService: PriceService)
    {
        super();
        this.orderService = orderService;
        this.priceService = priceService;
    }

    public async open(): Promise<void>
    {
        const orderPurchase = await this.orderService.getLastOrderPurchase();

        if (orderPurchase == null)
        {
            console.log('order purchase not set');
        }

        const order = orderPurchase.order;
        if (order == null)
        {
            /// Ooops
            return;
        }

        this.priceSubscription = this.priceService.getPriceByOrder(order).subscribe(
            priceData => {
                this.frameUri = `/payment?amount=${priceData.fmtPrice}&orderid=${order.Id}`;
                super.open();
            }
        );
    }

    public ngOnDestroy(): void
    {
        if (this.priceSubscription != null)
        {
            this.priceSubscription.unsubscribe();
        }
    }
}
